<template>
	<div class=".gg-container-1">
	  <div class="search-container">
		<div class="search-container-fn-input">
		  <label>关键字：</label>
		  <el-input
			style="width: 200px"
			size="small"
			placeholder="关键字搜索"
			prefix-icon="el-icon-search"
			clearable
			@change="getList"
			v-model="searchParams.keywords"
		  >
		  </el-input>
		</div>
		
			<el-button
				size="mini"
				type="primary"
				style="padding: 6px 7px;margin-left: 5px;
                              background-color: #2362FB; border-color: #2362FB"
				@click="getList"
			>
				<span>查找</span>
			</el-button>
			
		<div
		  style="margin-left: auto; display: flex; justify-content: space-around"
		>
		  <div class="search-container-fn-input" style="margin-left: auto;" v-if="operateList.indexOf('import') > -1">
			<el-button
			  size="mini"
			  type="success"
			  style="padding: 6px 7px 7px 8px;background-color: #FCC810; border-color: #FCC810"
			  @click="handlerDownloadTemplate"
			>
			  <i class="el-icon-download" style="font-size: 13px" />
			  <!--<a style="margin-left: 5px; font-size: 12px; " href="file/PatientRecords.xlsx">下载模板</a>-->
			  <span style="margin-left: 5px; font-size: 12px; ">下载模板</span>
			</el-button>
		  </div>
		  <div class="search-container-fn-input" style="margin-left: 10px" v-if="operateList.indexOf('import') > -1">
			<upload-excel-component
			  :on-success="handleSuccess"
			  :before-upload="beforeUpload"
			/>
		  </div>
		  <div class="search-container-fn-input" v-if="operateList.indexOf('delete') > -1">
			<el-button
			  size="mini"
			  type="primary"
			  icon="el-icon-refresh"
			  style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
										  background-color: #2362FB; border-color: #2362FB"
			  @click="handleDelete(multipleSelectionPres[0])"
			  v-if="multipleSelectionPres.length == 1"
			  >删除
			</el-button>
		  </div>
		  <div class="search-container-fn-input" v-if="operateList.indexOf('update') > -1">
			<el-button
			  size="mini"
			  type="primary"
			  icon="el-icon-refresh"
			  style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
										  background-color: #2362FB; border-color: #2362FB"
			  @click="handleEdit(multipleSelectionPres[0])"
			  v-if="multipleSelectionPres.length == 1"
			  >编辑
			</el-button>
		  </div>
		  <div class="search-container-fn-input" v-if="operateList.indexOf('update_table') > -1">
			<el-button
			  size="mini"
			  type="primary"
			  icon="el-icon-edit-outline"
			  style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
											background-color: #2362FB; border-color: #2362FB"
			  @click="handleEditTableHead"
			  >编辑表头
			</el-button>
		  </div>
		  <div class="search-container-fn-input" v-if="operateList.indexOf('reset_query') > -1">
			<el-button
			  size="mini"
			  type="primary"
			  icon="el-icon-refresh"
			  style="margin-right: 10px; padding: 6px 7px;margin-left: 5px;
											background-color: #2362FB; border-color: #2362FB"
			  @click="handleResetSearch"
			  >重置查找
			</el-button>
		  </div>
		  <!--对应第三方图标的button样式-->
		</div>
	  </div>
	  <!----------------表格---------------->
	  <el-table
		border
		size="mini"
		v-loading="listLoading"
		:header-cell-style="{ 'text-align': 'center' }"
		:data="tableData"
		height="725"
		@selection-change="handleSelectionChange"
		style="width: 100%;z-index:0"
	  >
		<el-table-column type="selection" width="55" align="center" />
		<el-table-column type="index" align="center" width="50">
		</el-table-column>
		<template v-for="(column, index) in tableHead">
		  <el-table-column
			:prop="column.column_prop"
			:label="
			  column.column_label_user_definition
				? column.column_label_user_definition
				: column.column_label
			"
			:width="column.width ? column.width : ''"
			:key="index"
			align="center"
			v-if="column.field_type === 'textBtn' && column.visible === true"
			show-overflow-tooltip
		  >
			<template slot-scope="scope">
			  <a
				style="font-size: 12px; color: #2379fb"
				@click.prevent="editArticle('view', scope.row)"
			  >
				{{ scope.row[column.column_prop] }}
			  </a>
			</template>
		  </el-table-column>
		  <!-- <el-table-column
          :prop="column.column_prop"
          :label="
            column.column_label_user_definition
              ? column.column_label_user_definition
              : column.column_label
          "
          :width="column.width ? column.width : ''"
          :key="index"
          align="center"
          v-else-if="
            column.field_type === 'image' &&
              column.visible === true
          "
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-avatar :src="scope.row.head_portrait"></el-avatar>
          </template>
        </el-table-column> -->
		  <el-table-column
			:prop="column.column_prop"
			:label="
			  column.column_label_user_definition
				? column.column_label_user_definition
				: column.column_label
			"
			:width="column.width ? column.width : ''"
			:key="index"
			align="center"
			v-else-if="column.field_type === 'select' && column.visible === true"
			show-overflow-tooltip
		  >
			<template slot-scope="scope">
			  <el-switch
				class="switch"
				@change="changeExamine(scope.row)"
				v-model="scope.row.status"
				:active-value="1"
				:inactive-value="0"
				active-text="启用"
				inactive-text="禁用"
				active-color="#13ce66"
				inactive-color="#C8C8C8"
			  >
			  </el-switch>
			</template>
		  </el-table-column>
		  <el-table-column
			:sortable="tableHeadSortable.includes(column.column_prop)"
			:prop="column.column_prop"
			:label="
			  column.column_label_user_definition
				? column.column_label_user_definition
				: column.column_label
			"
			:width="column.width ? column.width : ''"
			:key="index"
			align="center"
			v-else-if="column.visible === true"
			show-overflow-tooltip
		  >
			<template slot-scope="scope">
			  <a v-if="column.column_prop == 'supervise_status'">
				{{ scope.row.supervise_status | formatSuperviseStatus }}
			  </a>
			  <a v-else>{{ scope.row[column.column_prop] }}</a>
			</template>
			<template #header>
			  <el-popover
				placement="bottom"
				title=""
				min-width="160"
				trigger="click"
				v-if="
				  searchTableHead.filter(
					(item) => item.name == column.column_prop
				  ).length > 0
				"
			  >
				<span slot="reference" class="search-header">
				  <span class="search-title">{{
					column.column_label_user_definition
					  ? column.column_label_user_definition
					  : column.column_label
				  }}</span>
				  <i
					style="margin-left: 3px;font-weight: bolder; font-size: 20px"
					class="el-icon-search"
					:class="{
					  isSearch: searchTableHead.filter(
						(item) => item.name == column.column_prop
					  )[0].isSearch,
					  'el-icon-zoom-in': searchTableHead.filter(
						(item) => item.name == column.column_prop
					  )[0].isSearch,
					}"
				  />
				</span>
				<el-select
				  v-if="'source_name' == column.column_prop"
				  style="width: 200px"
				  @change="
					handleSearch(column.column_prop, searchParams.source_name)
				  "
				  v-model="searchParams.source"
				  clearable
				  placeholder="请选择"
				  size="small"
				>
				  <el-option
					v-for="(key, value) in source_name"
					:key="key"
					:label="key"
					:value="value"
				  >
				  </el-option>
				</el-select>
				<el-input
				  v-if="'mobile' == column.column_prop"
				  size="mini"
				  placeholder=""
				  prefix-icon="el-icon-search"
				  v-model="searchParams.mobile"
				  clearable
				  @change="handleSearch(column.column_prop, searchParams.mobile)"
				>
				</el-input>
			  </el-popover>
			  <span v-else>{{
				column.column_label_user_definition
				  ? column.column_label_user_definition
				  : column.column_label
			  }}</span>
			</template>
		  </el-table-column>
		</template>
	  </el-table>
  
	  <!----------------分页---------------->
	  <!--<pagination :total="total" :page.sync="listQuery.page" -->
	  <!--						:limit.sync="listQuery.limit"-->
	  <!--						@pagination="getList"/>-->
  
	  <pagination
		:total="total"
		:page.sync="listQuery.page"
		:limit.sync="listQuery.limit"
		@pagination="getList"
	  />
	  <!--编辑表头-->
	  <editTableHead
		:isActiveEditTableHead.sync="
		  isActiveEditTableHead
		"
		@_getAdminFieldIndex="_getAdminFieldIndex"
		v-if="isActiveEditTableHead"
		@getList="getList"
    :table_type="table_type"
	  >
	  </editTableHead>
	  <patientManagementDialogs
		v-if="isActiveDialogs"
		:isActiveDialogs.sync="isActiveDialogs"
		:patientManagementDialogsVisible.sync="patientManagementDialogsVisible"
		:handleClearInfo="handleClearInfo"
		:getList="getList"
		:info="info"
	  />
	  <!--drawer患者详情信息-->
	  <el-drawer
		v-loading="listLoading"
		:before-close="handleCloseDrawer"
		@closeDrawer="handleCloseDrawer"
		title=""
		size="76%"
		:visible.sync="drawerVisible"
		:with-header="false"
	  >
		<patientManagementDetails
		  @closeDrawer="closeDrawer"
		  :info="info"
		  v-if="drawerVisible"
		>
		</patientManagementDetails>
	  </el-drawer>
	  <el-dialog :visible.sync="dialogVisible" title="导入失败明细">
		<div style="margin-bottom: 15px;">
		  导入成功条数
		  <span style="color:green;">{{ dialogData.success }}</span>
		  条,导入失败条数
		  <span style="color: red;">{{ dialogData.fail }}</span> 条
		</div>
		<el-table :data="fail_info" style="max-height: 500px;overflow: auto;">
		  <el-table-column
			prop="patient_name"
			label="姓名"
			align="center"
		  ></el-table-column>
		  <el-table-column
			prop="patient_birthday"
			label="出生年月"
			align="center"
		  ></el-table-column>
		  <el-table-column
			prop="gender"
			label="性别"
			align="center"
			width="70"
		  ></el-table-column>
		  <el-table-column
			prop="patient_phone"
			label="电话"
			align="center"
		  ></el-table-column>
		  <el-table-column
			prop="address"
			label="地址"
			align="center"
			width="220"
		  ></el-table-column>
		  <el-table-column
			prop="error"
			label="失败原因"
			align="center"
		  ></el-table-column>
		</el-table>
	  </el-dialog>
	</div>
  </template>
  
  <script>
  import editTableHead from "@/components/editTableHead/editTableHead";
  import { getAdminFieldIndex } from "@/api/drugs2.0";
  import pagination from "@/components/Pagination";
  import UploadExcelComponent from "@/components/UploadExcel";
  import patientManagementDialogs from "./components/patientManagementDialogs";
  import patientManagementDetails from "./components/patientManagementDetails";
  import {
	getMemberList,
	delMember,
	postPatientImportPat,
  } from "@/api/patientManagement";
  import { mapState } from "vuex";
  export default {
	name: "patientManage",
	components: {
	  editTableHead,
	  pagination,
	  patientManagementDialogs,
	  patientManagementDetails,
	  UploadExcelComponent,
	},
	computed:{
		...mapState({
			table_options: (state) => state.user.table_options,
		})
	},
	async created() {
	  await this._getAdminFieldIndex();
	  await this.getList();
	},
	filters: {
	  genderFormat(v) {
		if (v === 0) {
		  return "未知";
		} else if (v === 1) {
		  return "男";
		} else {
		  return "女";
		}
	  },
	},
	mounted() {
    this.$store.dispatch("user/getOperates", this.$route.path).then((res) => {
      this.operateList = res;
    });
  },
	data() {
	  return {
      table_type:'patientManagement',
		operateList: [],
		isActiveEditTableHead: false,
		multipleSelectionPres: [],
		// multipleSelection1: [],
		activities: [],
		tableHead: [],
		searchTableHead: [
		  //控制搜索
		  {
			name: "mobile",
			isSearch: false,
		  },
		  {
			name: "source_name",
			isSearch: false,
		  },
		],
		tableHeadSortable: [
		  //控制排序
		  "created_at",
		  "expired_at",
		  "next_visit_at",
		  "end_visit_at",
		  "end_order_at",
		],
		dialogData: {},
		dialogVisible: false,
		fail_info: [],
		patientManagementDialogsVisible: false,
		isActiveDialogs: false,
		source_name: {
		  1: "患者场景",
		  2: "慢病场景",
		  4: "医生场景",
		},
		listLoading: false,
		searchParams: {
		  timeValue: [],
		},
		listQuery: {
		  page: 1,
		  limit: 100,
		  importance: undefined,
		  title: undefined,
		  type: undefined,
		  sort: "+id",
		},
		total: 0,
		tableData: [],
		info: {},
		drawerVisible: false,
	  };
	},
	methods: {
	  handleSelectionChange(val) {
		console.log(val);
		let tmp = val.map((v, k, a) => {
		  return v.appraise_id;
		});
		this.multipleSelection = `[${tmp.join(",")}]`;
		console.log(this.multipleSelection, 43435435);
		this.multipleSelectionPres = [];
		val.forEach((item) => {
		  this.multipleSelectionPres.push(item);
		});
	  },
	  handleSearch(prop, value) {
		console.log(prop, value, "2312343");
		this.searchTableHead.forEach((item) => {
		  if (item.name == prop) {
			if (value == "") {
			  item.isSearch = false;
			} else {
			  item.isSearch = true;
			}
		  }
		});
		this.getList("restPage");
	  },
	  handleResetSearch() {
		this.searchParams = {
		  is_wx: "",
		  visit_level: "",
		  buy_count: "",
		};
		this.searchTableHead.forEach((item) => {
		  item.isSearch = false;
		});
		this.choiceDateCreateRecord = [];
		this.choiceDateExpire = [];
		this.choiceDateEndVisit = [];
		this.choiceDateEndOrder = [];
		this.choiceDateNextVisit = [];
		this.getList("restPage");
	  },
	  handleEditTableHead() {
		this.isActiveEditTableHead = true;
	  },
	  async _getAdminFieldIndex() {
		// try {
		//   this.listLoading = true;
		//   var params = {
		// 	type: "patientManagement",
		//   };
		//   const res = await getAdminFieldIndex(params);
		  this.tableHead = this.table_options.patientManagement;
		//   console.log(this.tableHead);
		// } catch (err) {
		//   //在此处理错误
		// } finally {
		//   this.listLoading = false;
		// }
	  },
	  getList(rest) {
		if (rest === "restPage") {
		  this.listQuery.page = 1;
		}
		this.listLoading = true;
		let params = {
		  ...this.searchParams,
		};
		params.page = this.listQuery.page;
		params.page_size = this.listQuery.limit;
		getMemberList(params)
		  .then((response) => {
			let data = response;
			if (data.code === 200) {
			  let _data = data.data;
			  this.total = _data.total;
			  this.listQuery.limit = Number(_data.per_page);
			  this.tableData = _data.list;
			}
			this.listLoading = false;
		  })
		  .catch((error) => {
			console.log(error);
			this.listLoading = false;
		  });
	  },
	  _postPatientImportPat(data) {
		postPatientImportPat(data)
		  .then((response) => {
			if (response.code == 200) {
			  if (response.data.fail.length == "0") {
				this.$message({
				  type: "success",
				  message: `导入成功条数${response.data.success}`,
				});
			  } else {
				this.dialogVisible = true;
				response.data.fail_info.forEach((item) => {
				  if (item.gender == "1") {
					item.gender = "男";
				  } else {
					item.gender = "女";
				  }
				});
				this.dialogData = response.data;
				this.fail_info = response.data.fail_info;
				console.log("this.fail_info", this.fail_info);
			  }
			  // this.$message({
			  // 	type: 'warning',
			  // 	message: `导入成功条数 ${response.data.success},导入失败条数 ${response.data.fail}`
			  // })
			} else {
			  this.$message({
				type: "error",
				message: response.message,
			  });
			}
			this.listLoading = false;
			this.getList();
		  })
		  .catch((error) => {
			console.log(error);
			this.$message({
			  type: "error",
			  message: "网络故障",
			});
		  });
	  },
	  isSelectable(row) {
		console.log(row);
		return row.sync_status !== 1;
	  },
	  handlerDownloadTemplate() {
		console.log(this.$refs.download);
		let a = document.createElement("a");
		a.href = `/file/webHospitalPatientTemplate.xlsx`;
		a.download = "互联网医院患者管理模板.xlsx";
		a.click();
	  },
	  beforeUpload(file) {
		// excel上传前
		console.log(file);
		const isLt1M = file.size / 1024 / 1024 < 3;
		console.log(isLt1M);
		if (isLt1M) {
		  return true;
		}
  
		this.$message({
		  message: "请传入excel大小不要超过3M.",
		  type: "warning",
		});
		return false;
	  },
	  handleSuccess({ results, header }) {
		// excel成功的结果
		console.log(results);
		let data = {
		  file: results,
		};
		console.log(data);
		this._postPatientImportPat(data);
		this.getList();
	  },
	  handleEdit(row) {
		this.info = row;
		this.isActiveDialogs = !this.isActiveDialogs;
		this.patientManagementDialogsVisible = !this
		  .patientManagementDialogsVisible;
	  },
	  handleDelete(row) {
		console.log(row);
		this.$confirm("确认删除文章?", "提示", {
		  confirmButtonText: "确定",
		  cancelButtonText: "取消",
		  type: "warning",
		})
		  .then(() => {
			console.log(row.id);
			delMember(row.id).then((res) => {
			  if (res.code == 200) {
				this.getList();
				this.$message({
				  type: "success",
				  message: "删除成功!",
				});
			  }
			});
		  })
		  .catch(() => {
			this.$message({
			  type: "info",
			  message: "已取消删除",
			});
		  });
	  },
	  handleAccountDetail(row) {
		this.info = row;
		this.drawerVisible = !this.drawerVisible;
	  },
	  handleClearInfo() {
		this.info = {};
	  },
	  handleCloseDrawer() {
		this.drawerVisible = false;
	  },
	  closeDrawer(e) {
		this.drawerVisible = e;
	  },
	},
  };
  </script>
  
  <style scoped lang="scss">
  .gg-container {
	position: relative;
  }
  
  .table-username {
	font-size: 14px;
	color: #2632fb;
 
	&:hover {
	  cursor: pointer;
	}
  }
  
  /*drawer*/
 ::v-deep .el-drawer {
	bottom: 0 !important;
  }
  
 ::v-deep .el-drawer__header {
	padding: 0;
	margin: 0;
  }
  
 ::v-deep .el-drawer.rtl {
	overflow: visible;
	height: 91vh;
	bottom: 0;
	margin-top: 9vh;
	position: absolute;
  }
  </style>
